class Stats {
	constructor(el) {
		this.statsBlock = el;

        // this.hasFired = false;
        // this.observer = new IntersectionObserver(this.startCounter, { threshold: 1 });
        // this.observer.observe(this.statsBlock);
        // if(this.statsBlock.isIntersecting) {
        //     console.log('fired');
        //     this.observer.unobserve(this.statsBlock);
        // }
        this.eventHandler(this.statsBlock);
        // console.log(this.hasFired);
    }

    eventHandler(statsBlock) {
        const observer = new IntersectionObserver(el => {
            console.log(el);
            if(el[0].isIntersecting) {
                console.log('Intersect');
                observer.unobserve(statsBlock);
            }
            statsBlock.querySelectorAll('.number').forEach(function (stat) {
                var statText = stat.textContent;
                var val = Number(statText.replace(/\D/g, '')); // Extract numeric part

                if (!isNaN(val)) {
                    // Create a counter object with initial value 0
                    var counter = { Counter: 0 };
            
                    // Use requestAnimationFrame for smoother animation
                    function animateCounter() {
                        counter.Counter += (val - counter.Counter) * 0.05; // Adjust the animation speed here
                        stat.textContent = Math.ceil(counter.Counter).toLocaleString();
            
                        if (Math.abs(val - counter.Counter) > .1) {
                            // Continue animating
                            requestAnimationFrame(animateCounter);
                        } else {
                            // Animation complete, set the final value
                            stat.textContent = statText.toLocaleString();
                        }
                    }

                    
                    // Start the animation
                    animateCounter();
                }
            },
        )}, { threshold: 1 });

        observer.observe(statsBlock);
    }

    startCounter(element, observer) {
        document.querySelectorAll('.number').forEach(function (stat) {
            var statText = stat.textContent;
            var val = Number(statText.replace(/\D/g, '')); // Extract numeric part

            if (!isNaN(val)) {
                // Create a counter object with initial value 0
                var counter = { Counter: 0 };
        
                // Use requestAnimationFrame for smoother animation
                function animateCounter() {
                    counter.Counter += (val - counter.Counter) * 0.05; // Adjust the animation speed here
                    stat.textContent = Math.ceil(counter.Counter).toLocaleString();
        
                    if (Math.abs(val - counter.Counter) > .1) {
                    // if (val != counter.Counter) {
                        // Continue animating
                        requestAnimationFrame(animateCounter);
                    } else {
                        // Animation complete, set the final value
                        stat.textContent = statText.toLocaleString();
                    }
                }
        
                // Start the animation
                animateCounter();
            }
        });
    }
}

export default Stats;